export default "__VITE_ASSET__WUH$JXHM__";